import qs from 'qs';
import {
    mockAccountFlowList,
    mockBetRecordList,
    mockMemberList,
    mockMembers,
    mockReportList,
} from '@/mock/data';

let memberListState = mockMemberList.map((item) => ({ ...item }));

function delay(ms) {
    return new Promise((resolve) => {
        setTimeout(resolve, ms);
    });
}

function ok(data, message = 'ok') {
    return {
        code: '200',
        isSucceed: true,
        message,
        data,
    };
}

function fail(message, code = '400') {
    return {
        code,
        isSucceed: false,
        message,
    };
}

function parseBody(config) {
    if (!config.data) {
        return {};
    }
    if (typeof config.data === 'string') {
        return qs.parse(config.data);
    }
    return config.data;
}

function parseQuery(config) {
    const url = config.url || '';
    const queryIndex = url.indexOf('?');
    if (queryIndex === -1) {
        return {};
    }
    return qs.parse(url.slice(queryIndex + 1));
}

function getMemberList() {
    return Object.values(mockMembers);
}

function getPath(config) {
    const url = config.url || '';
    return url.split('?')[0];
}

async function mockLogin(params) {
    await delay(600);
    return ok({
        token: `mock-token-${Date.now()}`,
        account: params.account,
    }, '登录成功');
}

async function mockChangePassword(payload) {
    await delay(600);

    if (!payload.oldPassword) {
        return fail('请输入原密码');
    }
    if (!payload.newPassword) {
        return fail('请输入新密码');
    }
    if (payload.newPassword !== payload.confirmPassword) {
        return fail('两次密码不一致');
    }
    if (payload.newPassword.length < 6) {
        return fail('新密码至少6位');
    }

    return ok(null, '修改成功');
}

async function mockAddMember(payload) {
    await delay(600);

    if (!payload.nickname) {
        return fail('请输入昵称');
    }
    if (!payload.loginAccount) {
        return fail('请输入账号');
    }

    const exists = getMemberList().some(
        (item) => (item.loginAccount || item.account) === payload.loginAccount,
    );
    if (exists) {
        return fail('账号已存在');
    }

    if (!payload.loginPassword) {
        return fail('请输入密码');
    }
    if (payload.loginPassword !== payload.confirmPassword) {
        return fail('两次密码不一致');
    }
    if (payload.loginPassword.length < 6) {
        return fail('密码至少6位');
    }

    return ok({
        nickname: payload.nickname,
        loginAccount: payload.loginAccount,
    }, '新增成功');
}

async function mockSearchMembers(keyword) {
    await delay(200);

    const kw = String(keyword || '').trim().toLowerCase();
    if (!kw) {
        return ok({ list: [] });
    }

    const list = getMemberList().filter((member) => (
        member.account.includes(kw)
        || member.nickname.includes(String(keyword || '').trim())
        || `${member.nickname} - ${member.account}`.toLowerCase().includes(kw)
    ));

    return ok({ list });
}

function findMemberById(userId) {
    return getMemberList().find((member) => String(member.id) === String(userId)) || null;
}

async function mockMemberTopUp(payload) {
    await delay(600);

    if (!payload.userId) {
        return fail('请选择会员');
    }

    const member = findMemberById(payload.userId);
    if (!member) {
        return fail('会员不存在', '404');
    }

    if (!payload.topUpAmount || payload.topUpAmount <= 0) {
        return fail('请输入有效的上分金额');
    }

    return ok({
        userId: member.id,
        topUpAmount: payload.topUpAmount,
    }, `已为 ${member.nickname} 上分 ${payload.topUpAmount}`);
}

function filterMemberList(keyword) {
    const kw = String(keyword || '').trim().toLowerCase();
    if (!kw) {
        return [...memberListState];
    }

    return memberListState.filter((member) => (
        member.account.includes(kw)
        || member.nickname.includes(String(keyword || '').trim())
        || `${member.nickname} - ${member.account}`.toLowerCase().includes(kw)
    ));
}

async function mockFetchMemberList(keyword, page = 1) {
    await delay(300);
    const PAGE_SIZE = 20;
    const all = filterMemberList(keyword);
    const start = (Number(page) - 1) * PAGE_SIZE;
    return ok({ recordList: all.slice(start, start + PAGE_SIZE) });
}

async function mockToggleMemberStatus(payload) {
    await delay(400);

    const member = memberListState.find((item) => item.account === payload.account);
    if (!member) {
        return fail('会员不存在', '404');
    }

    member.status = member.status === 'disabled' ? 'normal' : 'disabled';
    const message = member.status === 'disabled' ? '已停用' : '已启用';
    return ok({ status: member.status }, message);
}

async function mockResetMemberPassword(payload) {
    await delay(400);

    const member = memberListState.find((item) => item.account === payload.account);
    if (!member) {
        return fail('会员不存在', '404');
    }

    if (!payload.password) {
        return fail('请输入新密码');
    }

    if (payload.password !== payload.confirmPassword) {
        return fail('两次密码不一致');
    }

    if (payload.password.length < 6) {
        return fail('新密码至少6位');
    }

    return ok(null, `已重置 ${member.nickname} 的密码`);
}

function filterAccountFlowList(keyword) {
    const kw = String(keyword || '').trim().toLowerCase();
    if (!kw) {
        return [...mockAccountFlowList];
    }

    return mockAccountFlowList.filter((item) => (
        item.account.includes(kw)
        || item.nickname.includes(String(keyword || '').trim())
        || item.title.includes(String(keyword || '').trim())
        || `${item.nickname} - ${item.account}`.toLowerCase().includes(kw)
    ));
}

async function mockFetchAccountFlowList(keyword, page = 1) {
    await delay(300);
    const PAGE_SIZE = 20;
    const all = filterAccountFlowList(keyword);
    const start = (Number(page) - 1) * PAGE_SIZE;
    return ok({ list: all.slice(start, start + PAGE_SIZE) });
}

function filterBetRecordList(keyword) {
    const kw = String(keyword || '').trim().toLowerCase();
    if (!kw) {
        return [...mockBetRecordList];
    }

    return mockBetRecordList.filter((item) => (
        (item.login_account || item.account || '').includes(kw)
        || item.nickname.includes(String(keyword || '').trim())
        || `${item.nickname} - ${item.login_account || item.account || ''}`.toLowerCase().includes(kw)
    ));
}

async function mockFetchBetRecordList(keyword, page = 1) {
    await delay(300);
    const PAGE_SIZE = 20;
    const all = filterBetRecordList(keyword);
    const start = (Number(page) - 1) * PAGE_SIZE;
    return ok({ recordList: all.slice(start, start + PAGE_SIZE) });
}

async function mockFetchReportList() {
    await delay(300);
    return ok({ list: [...mockReportList] });
}

/**
 * 开发环境 Mock 响应
 * @param {import('axios').AxiosRequestConfig} config
 */
export async function resolveMock(config) {
    const path = getPath(config);
    const method = (config.method || 'get').toLowerCase();
    const body = parseBody(config);
    const query = parseQuery(config);

    if (method === 'post' && path === '/app/login') {
        return mockLogin(body);
    }

    if (method === 'get' && path === '/agent/home') {
        await delay(300);
        return ok({
            balance: 3069.25,
            onlineCount: 58,
            memberCount: 240,
        });
    }

    if (method === 'post' && path === '/agent/changePassword') {
        return mockChangePassword(body);
    }

    if (method === 'post' && path === '/agent/member/add') {
        return mockAddMember(body);
    }

    if (method === 'get' && path === '/agent/member/isExistLoginAccount') {
        await delay(200);
        const account = String(query.val || '').trim();
        const exists = getMemberList().some(
            (item) => (item.loginAccount || item.account) === account,
        );
        return ok(exists);
    }

    if (method === 'get' && path === '/agent/member/search') {
        return mockSearchMembers(query.keyword);
    }

    if (method === 'post' && path === '/agent/member/topUp') {
        return mockMemberTopUp(body);
    }

    if (method === 'get' && path === '/agent/member/list') {
        return mockFetchMemberList(query.keyword, query.page);
    }

    if (method === 'post' && path === '/agent/member/toggleStatus') {
        return mockToggleMemberStatus(body);
    }

    if (method === 'post' && path === '/agent/member/resetPassword') {
        return mockResetMemberPassword(body);
    }

    if (method === 'get' && path === '/agent/flow/list') {
        return mockFetchAccountFlowList(query.keyword, query.page);
    }

    if (method === 'get' && path === '/agent/bet/list') {
        return mockFetchBetRecordList(query.keyword, query.page);
    }

    if (method === 'get' && path === '/agent/report/list') {
        return mockFetchReportList();
    }

    return undefined;
}
